<template>
  <div>
    <v-dialog v-model="open" max-width="600px" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-if="fab"
            fab
            dark
            fixed
            bottom
            right
            color="primary"
            v-bind="attrs"
            v-on="on"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
            v-else
            v-bind="attrs"
            v-on="on"
            text
            small
            color="info"
        >
          Editar
        </v-btn>
      </template>

      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ id ? 'Editar' : 'Criar' }} postagem</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
              icon
              @click="open = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <location-post-form
            :location-name="locationName"
            :location-phone="locationPhone"
            :id="id"
            :title="title"
            :summary="summary"
            :prop-type="type"
            :action-button-link="actionButtonLink"
            :action-button-type="actionButtonType"
            :created-at="createdAt"
            :alert-type="alertType"
            :event-schedule="eventSchedule"
            :event-schedule-code="eventScheduleCode"
            :offer-coupon-code="offerCouponCode"
            :offer-redeem-online-url="offerRedeemOnlineUrl"
            :offer-terms-and-conditions="offerTermsAndConditions"
            :open-date="openDate"
            :open-time="openTime"
            :close-date="closeDate"
            :close-time="closeTime"
            :image="image"
            :media-format="mediaFormat"
            :bulk-update="bulkUpdate"
            :bulk-params="bulkParams"
            :on-updated="onPostSaved"
            :on-bulk-updated="onPostBulkUpdated"
        />
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import * as postsConstants from '@/constants/posts'
import LocationPostForm from '@/views/Locations/Modals/LocationPostForm'

export default {
  name: 'LocationPostModal',
  components: {
    LocationPostForm
  },
  props: {
    startOpen: {
      type: Boolean,
      default: false
    },
    fab: Boolean,
    bulkUpdate: Boolean,
    bulkParams: Object,
    locationName: {
      required: true,
      type: String
    },
    locationPhone: String,
    onUpdated: Function,
    onBulkUpdated: Function,
    id: Number,
    title: String,
    image: String,
    mediaFormat: String,
    summary: String,
    propType: String,
    actionButtonType: String,
    actionButtonLink: String,
    createdAt: String,
    alertType: String,
    eventSchedule: String,
    eventScheduleCode: String,
    offerRedeemOnlineUrl: String,
    offerCouponCode: String,
    offerTermsAndConditions: String,
    openDate: String,
    openTime: String,
    closeDate: String,
    closeTime: String,
  },
  data: () => ({
    loading: false,
    open: false,
    form: {
      actionButtonType: '',
      actionButtonLink: '',
      summary: '',
      title: '',
      openDate: '',
      openTime: '',
      closeDate: '',
      closeTime: '',
      offerCouponCode: '',
      offerRedeemOnlineUrl: '',
      offerTermsAndConditions: '',
      details: '',
      image: ''
    },
    type: postsConstants.ALERT_TYPE
  }),
  created() {
    this.open = this.startOpen
  },
  watch: {
    open: function (open) {
      if (open) {
        this.type = this.propType || postsConstants.ALERT_TYPE
        this.form = {
          actionButtonType: this.actionButtonType,
          actionButtonLink: this.actionButtonLink,
          summary: this.summary,
          title: this.title,
          openDate: this.openDate,
          openTime: this.openTime,
          closeDate: this.closeDate,
          closeTime: this.closeTime,
          offerCouponCode: this.offerCouponCode,
          offerRedeemOnlineUrl: this.offerRedeemOnlineUrl,
          offerTermsAndConditions: this.offerTermsAndConditions,
          details: ''
        }
      }
    }
  },
  methods: {
    onPostSaved() {
      if (this.onUpdated) {
        this.onUpdated()
      }
      this.open = false
    },
    onPostBulkUpdated() {
      if (this.onBulkUpdated) {
        this.onBulkUpdated()
      }
      this.open = false
    }
  }
}
</script>

<style scoped>

</style>